"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function onChange(propName, fn) {
    return create_1.create({
        initialize: function () {
            this._prevProps = this.props;
            this._own = {};
            this._i = false;
        },
        handleReceivedProps: function (parentProps) {
            var _this = this;
            if (!this._i) {
                this._i = true;
                return;
            }
            var detector = typeof propName === 'string'
                ? function (p, n) { return p[propName] !== n[propName]; }
                : propName;
            this.set(Object.assign({}, parentProps, this._own));
            var cb = function (newProps) {
                _this._own = newProps;
                _this.set(newProps);
            };
            if (detector(this._prevProps, parentProps)) {
                var result = fn(parentProps, this.providers, cb);
                if (result) {
                    cb(result);
                }
            }
            this._prevProps = this.props;
        },
    });
}
exports.onChange = onChange;
//# sourceMappingURL=onChange.js.map